import { Link } from 'react-router-dom';
import { BeneficiariosIcon, PrestadoresIcon, LocalizacaoIcon, PlanosIcon, ServicosIcon, SegurancaIcon } from '../components/Icons';
import { useState } from 'react';
import { useAuth } from '../auth/AuthContext';

const cardBaseStyle: React.CSSProperties = {
  backgroundColor: 'var(--surface-primary)',
  borderRadius: 'var(--radius-lg)',
  padding: '1.5rem',
  boxShadow: 'var(--shadow-md)',
  cursor: 'pointer',
  transition: 'transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out',
  display: 'flex',
  alignItems: 'center',
  textDecoration: 'none',
  gap: '1.5rem',
};

const cardTitleStyle: React.CSSProperties = {
  fontSize: '1.125rem',
  fontWeight: 700,
  color: 'var(--text-primary)',
  margin: 0,
};

const gridStyle: React.CSSProperties = {
  display: 'grid',
  gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
  gap: '1.5rem',
};

interface ModuleCardProps {
    title: string;
    icon: React.ReactNode;
    to: string;
}

function ModuleCard({ title, icon, to }: ModuleCardProps) {
  const [isHovered, setIsHovered] = useState(false);
  const cardStyle: React.CSSProperties = {
    ...cardBaseStyle,
    transform: isHovered ? 'translateY(-4px)' : 'translateY(0)',
    boxShadow: isHovered ? 'var(--shadow-lg)' : 'var(--shadow-md)',
  };

  return (
    <Link
      to={to}
      style={cardStyle}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      aria-label={`Acessar módulo ${title}`}
    >
      {icon}
      <h3 style={cardTitleStyle}>{title}</h3>
    </Link>
  );
}

function Dashboard() {
  const { hasPermission } = useAuth();
  
  return (
    <div>
      <header className="page-header">
        <h2 className="page-title">Módulos</h2>
      </header>
      <div style={gridStyle}>
        {hasPermission('beneficiario_CA001_BENEFICIARIO', 'Select') && (
            <ModuleCard 
              title="Beneficiários" 
              icon={<BeneficiariosIcon />}
              to="/beneficiarios"
            />
        )}
        {hasPermission('prestador_CA001_PRESTADOR', 'Select') && (
            <ModuleCard 
              title="Prestadores" 
              icon={<PrestadoresIcon />}
              to="/prestadores" 
            />
        )}
        {hasPermission('plano_CA001_PLANO', 'Select') && (
            <ModuleCard 
              title="Planos" 
              icon={<PlanosIcon />}
              to="/planos"
            />
        )}
        {hasPermission('servico_CA001_SERVICO', 'Select') && (
            <ModuleCard 
              title="Serviços" 
              icon={<ServicosIcon />}
              to="/servicos"
            />
        )}
        {hasPermission('localizacao_CA005_GRANDE_REGIAO', 'Select') && (
            <ModuleCard 
              title="Localização" 
              icon={<LocalizacaoIcon />}
              to="/localizacao"
            />
        )}
        {hasPermission('seguranca_CA001_USUARIOS', 'Select') && (
            <ModuleCard 
              title="Segurança" 
              icon={<SegurancaIcon />}
              to="/seguranca"
            />
        )}
      </div>
    </div>
  );
}

export default Dashboard;